import React, { useState, useEffect } from 'react';
import { StreamingService } from '../services/streaming';

const TrendingSection = ({ limit = 10 }) => {
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTrending();
    const interval = setInterval(loadTrending, 60000); // Refresh every minute
    return () => clearInterval(interval);
  }, [limit]);

  const loadTrending = async () => {
    try {
      const data = await StreamingService.getTrending(limit);
      setTrending(data);
    } catch (error) {
      console.error('Error loading trending:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToWatchlist = async (videoId) => {
    try {
      await StreamingService.addToWatchlist(videoId);
      alert('Added to watchlist!');
    } catch (error) {
      alert('Failed to add to watchlist');
    }
  };

  if (loading) {
    return (
      <div className="animate-pulse">
        <div className="h-8 bg-gray-700 rounded w-48 mb-4"></div>
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-24 bg-gray-800 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-900/50 rounded-lg p-6 border border-gray-700">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
          🔥 Trending Now
        </h2>
        <div className="text-sm text-gray-400">
          Updated 1 min ago
        </div>
      </div>

      <div className="space-y-4">
        {trending.map((item, index) => {
          const video = item.video;
          const score = item.score;

          return (
            <div
              key={video.id || index}
              className="flex gap-4 p-4 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition-all cursor-pointer group"
            >
              {/* Rank */}
              <div className="flex-shrink-0">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center font-bold text-2xl ${
                  index === 0 ? 'bg-gradient-to-br from-yellow-400 to-orange-500 text-white' :
                  index === 1 ? 'bg-gradient-to-br from-gray-300 to-gray-500 text-white' :
                  index === 2 ? 'bg-gradient-to-br from-orange-400 to-orange-600 text-white' :
                  'bg-gray-700 text-gray-400'
                }`}>
                  {index === 0 ? '👑' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
                </div>
              </div>

              {/* Thumbnail */}
              <div className="flex-shrink-0 w-32 h-20 bg-gradient-to-br from-red-900/50 to-orange-900/50 rounded-lg overflow-hidden">
                {video.thumbnail_url ? (
                  <img src={video.thumbnail_url} alt={video.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-3xl">🎬</div>
                )}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <h3 className="text-white font-bold text-lg mb-1 line-clamp-1 group-hover:text-orange-400 transition-colors">
                  {video.title}
                </h3>
                <p className="text-gray-400 text-sm mb-2 line-clamp-1">
                  {video.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span className="flex items-center gap-1">
                    <span className="text-red-500">🔥</span>
                    {score.toFixed(0)} trending score
                  </span>
                  <span>⭐ {video.rating ? video.rating.toFixed(1) : 'N/A'}</span>
                  <span>👁️ {video.views ? video.views.toLocaleString() : 0}</span>
                </div>
              </div>

              {/* Action */}
              <div className="flex-shrink-0 flex items-center">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToWatchlist(video.id);
                  }}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg font-bold text-sm transition-all opacity-0 group-hover:opacity-100"
                >
                  Watch
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrendingSection;